import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";
import { DATA_TYPES } from "@modules/data/ManualInput";

class SettlementByAmountComponent extends Component {
  state = {
    settlementFormByAmountTotal: new Form(
      {
        availableBalance: "",
        requestedSettlement: "",
        balanceToSettle: "",
        propertyId: "",
      },
      [
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "requestedSettlement",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "propertyId",
          type: "isString",
          rules: {
            required: true,
          },
        }
      ]
    ),
    settlementByAmountBaseMidRowFields: [
      {
        name: "provider",
        label: "Provider",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "method",
        label: "Method",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "idTPlusX",
        label: "MID",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.25"
      }, {
        name: "name",
        label: "Tags",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "date",
        label: "Date",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.2",
      }, {
        name: "withheldFunds",
        label: "Disputed Funds",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        hideColumn: false
      }, {
        name: "walletBalance",
        label: "Payout Wallet",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.3",
        hideColumn: false,
        rightAlign: true,
      },{
        name: "pendingPayouts",
        label: "Pending Payouts",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        hideColumn: false,
        rightAlign: true,
      }, {
        name: "availableBalance",
        label: "Available Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        rightAlign: true,
      }, {
        name: "balanceToSettle",
        label: "Balance to Settle",
        fieldType: "input",
        flexGrow: "0.25",
        updateRequestedField: true,
        rightAlign: true,
      }, {
        name: "checkBox",
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onMidSelect(index, DATA_TYPES.SETTLEMENT_BY_AMOUNT),
        disabled: true,
        alignSelf: "end",
        flexGrow: "0"
      }
    ],
    settlementByAmountBaseFields: [[
      {
        name: "currency",
        label: "MID Currency",
        disabled: true,
        fieldType: "input",
      },
      {
        name: "availableBalance",
        label: "Total Available Balance",
        fieldType: "input",
        formatValue: true,
        disabled: true,
      },
      {
        name: "requestedSettlement",
        label: "Available Balance Reduction",
        fieldType: "input",
      },
      {
        name: "balanceToSettle",
        label: "Balance to Settle",
        disabled: true,
        fieldType: "input",
        formatValue: true,
      },
      {
        name: "propertyId",
        label: "Status",
        fieldType: "select",
        getOptions: () => this.getOptionsFromState("statuses"),
        items: "statuses",
      },
    ],
    [
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      {
        name: "notes",
        label: "Notes",
        fieldType: "textarea",
        flexGrow: "1",
      },
      { fieldType: "button" },
    ]]
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  };

  populateSettlementByAmountForm = (controls, responseMids) => {
    const { settlementByAmountBaseMidRowFields, settlementByAmountBaseFields, settlementFormByAmountTotal } = this.state;
    let SETTLEMENT_BY_AMOUNT = [];
    const settlementFormByAmount = [];
    const stateForUpdate = {};

    let availableBalance = 0;
    responseMids.forEach((midInfo) => {
      const midForm = this.getMidRowSettlementByAmountForm(midInfo);
      if (midForm.payoutWalletType !== "") {
        this.addPostValue(midForm, "walletBalance", midForm.payoutWalletType);
      }
      settlementFormByAmount.push(midForm);
      SETTLEMENT_BY_AMOUNT.push(settlementByAmountBaseMidRowFields);
      availableBalance += parseFloat(midInfo.availableBalance);
    });

    const notesForm = new Form({
      notes: ""
    }, [{
      name: "notes",
      type: "isString",
      rules: {
        required: false,
      },
    }]);
    Object.assign(settlementFormByAmountTotal, {
      availableBalance: parseFloat((availableBalance).toFixed(2)) || 0,
      propertyId: "18",
      currency: controls.currency || "",
      requestedSettlement: "",
      balanceToSettle: 0
    });
    Object.assign(stateForUpdate, {
      settlementFormByAmountTotal: settlementFormByAmountTotal,
      settlementFormByAmountMids: [...settlementFormByAmount],
      settlementMids: [...settlementFormByAmount]
    });

    SETTLEMENT_BY_AMOUNT.push([]);
    SETTLEMENT_BY_AMOUNT = SETTLEMENT_BY_AMOUNT.concat(settlementByAmountBaseFields);
    this.updateField(DATA_TYPES.SETTLEMENT_BY_AMOUNT, SETTLEMENT_BY_AMOUNT);
    settlementFormByAmount.push(new Form(), settlementFormByAmountTotal, notesForm);
    Object.assign(stateForUpdate, {
      settlementFormByAmount: settlementFormByAmount
    });
    return stateForUpdate;
  };

  addPostValue = (form, fieldName, value) => {
    form[fieldName + "PostValue"] = (
      <span className={ `txValue-inputMask ${value === "N/A" ? 'full-width' : ''}` }>({value})</span>
    );
  };

  getMidRowSettlementByAmountForm = (midInfo) => {
    const { getTXValue } = this.props;
    return new Form(
      {
        id: midInfo.id,
        idTPlusX: `${midInfo.id} (T+${getTXValue(midInfo.id)})`,
        name: midInfo.name,
        method: midInfo.method,
        provider: midInfo.providerName,
        date: midInfo.date,
        pendingPayouts: parseFloat(midInfo.pendingPayouts) || 0,
        availableBalance: parseFloat(midInfo.availableBalance) || 0,
        walletBalance: parseFloat(midInfo.walletBalance) || 0,
        payoutWalletType: midInfo.payoutWalletType || "",
        balanceToSettle: 0,
        providerName: midInfo.providerName || '',
        withheldFunds: parseFloat(midInfo.withheldFunds) || 0,
        disabled: false,
        isChecked: false
      },
      [
        {
          name: "id",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "name",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "method",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "provider",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "pendingPayouts",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "walletBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "payoutWalletType",
          type: "isString",
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "withheldFunds",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "disabled",
          type: "isBoolean",
          rules: {
            required: true,
          },
        },
        {
          name: "isChecked",
          type: "isBoolean",
          rules: {
            required: true,
          }
        }
      ]
    );
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    const { settlementByAmountBaseMidRowFields } = this.state;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, dataType, midIds } = controls;

      const url = `v1/data/input?clientId=${ merchant }&dataInputTypes=${ dataType }&midIds=${ midIds }`;

      crudActions.get(url)
        .then((response) => {
          if (response.length) {
            // Do not display column if value in each row === 0
            const disputedFundsField = settlementByAmountBaseMidRowFields.find(field => field.name === "withheldFunds");
            disputedFundsField.hideColumn = !response.some(row => row.withheldFunds !== 0);
            const payoutWalletField = settlementByAmountBaseMidRowFields.find(field => field.name === "walletBalance");
            payoutWalletField.hideColumn = !response.some(row => row.walletBalance !== 0);
            const pendingPayoutsField = settlementByAmountBaseMidRowFields.find(field => field.name === "pendingPayouts");
            pendingPayoutsField.hideColumn = !response.some(row => row.pendingPayouts !== 0);

            const newState =  this.populateSettlementByAmountForm(controls, response);
            Object.assign(newState, {
              showSecondPanel: true,
              loadingDataInput: false,
              lockButton: false,
            });
            this.updateState(newState);
          } else {
            this.errorUpdate("The selected MIDs has no available balance.");
          }
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };

  onSaveDataEntries = () => {
    const { savedData, form, formTotal, settlementMids } = this.props;

    const isSettlementFormValid = form.map((elem) => elem.isFormValid()).every(Boolean);
    this.SaveValidationUpdate(form, isSettlementFormValid, isSettlementFormValid && formTotal.balanceToSettle > 0, true);
    const notes = form[form.length - 1].notes;

    if (isSettlementFormValid) {
      if (formTotal.balanceToSettle > 0) {
        const data = settlementMids.filter(m => parseFloat(m.balanceToSettle) > 0).map((mid) => {
          return {
            id: mid.id,
            name: mid.name,
            method: mid.method,
            walletBalance: mid.walletBalance,
            pendingPayouts: mid.pendingPayouts,
            availableBalance: mid.availableBalance,
            balanceToSettle: mid.balanceToSettle,
            currency: formTotal.currency,
            date: mid.date,
            midId: mid.id,
            notes: notes,
            clientId: savedData.merchant,
            propertyId: formTotal.propertyId,
          };
        });

        crudActions.post(`v1/data/input/settlements/amount`, data)
          .then(() => {
            this.afterSuccessSave();
          })
          .catch((err) => {
            this.errorUpdate(err ? err.message : '');
          });
      } else {
        this.errorUpdate('Balance to Settle value should be greater than 0! Please, select at least one MID to proceed.');
      }
    }
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };

  SaveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = () => {
    this.props.updateStateAfterSuccessSave("Settlement successfully initiated.");
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default SettlementByAmountComponent;